import { Button, type ButtonVariantType, type IconName } from '@design-system';
import React, { type FC } from 'react';

interface ShareButtonProps {
  href?: string;
  onClick: () => void;
  icon: IconName;
  label: string;
  variant?: ButtonVariantType;
}

export const ShareButton: FC<ShareButtonProps> = ({
  href,
  icon,
  label,
  onClick,
  variant = 'tertiary',
}) => {
  if (href) {
    return (
      <Button
        as="a"
        hideLabel
        href={href}
        icon={icon}
        label={label}
        size="sm"
        target="_blank"
        variant={variant}
      />
    );
  }

  return (
    <Button
      hideLabel
      icon={icon}
      label={label}
      onClick={onClick}
      size="sm"
      variant={variant}
    />
  );
};
